// @unocss-include
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Icon } from '@a-type/ui';
import * as CONFIG from '../config.js';
import { useMaybeAppId } from './Context.js';
export function LoginButton(_a) {
    var { children, tab } = _a, props = __rest(_a, ["children", "tab"]);
    return (_jsx(Button, Object.assign({ asChild: true }, props, { children: _jsx(LoginLink, { tab: tab, returnTo: props.returnTo, children: children !== null && children !== void 0 ? children : (_jsxs(_Fragment, { children: ["Log in", _jsx(Icon, { name: "arrowRight" })] })) }) })));
}
export function LoginLink(_a) {
    var { children, tab, returnTo } = _a, props = __rest(_a, ["children", "tab", "returnTo"]);
    const url = new URL(CONFIG.HOME_ORIGIN + '/login');
    url.searchParams.set('returnTo', returnTo !== null && returnTo !== void 0 ? returnTo : window.location.href);
    const appId = useMaybeAppId();
    if (appId) {
        url.searchParams.set('appReferrer', appId);
    }
    if (tab) {
        url.searchParams.set('tab', tab);
    }
    return (_jsx("a", Object.assign({ href: url.toString() }, props, { children: children !== null && children !== void 0 ? children : _jsx(_Fragment, { children: "Log in" }) })));
}
//# sourceMappingURL=LoginButton.js.map